import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

const Radio = (props) => {
  const {
    name,
    value,
    label,
    checked = false,
    className,
    onChange,
    ...rest
  } = props;
  const componentClassName = "sal-radio";
  const classNames = classnames(componentClassName, className, {
    [`${componentClassName}--active`]: checked,
  });

  return (
    <label className={classNames}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        {...rest}
      />
      {label}
    </label>
  );
};

Radio.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.node,
  checked: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func,
};

export default Radio;
